var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('KPaginatedAutocomplete',_vm._g(_vm._b({ref:"autocomplete",attrs:{"paginator":_vm.autocomplete,"field":"purchaseOrderStatus","return-object":false}},'KPaginatedAutocomplete',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }